import { FC, useContext } from 'react'
import { StrapiDataItem } from '../../../../types/strapi/strapi'
import Stamp from '../../../../types/api/stamp'
import { Button } from 'antd'
import { AimOutlined } from '@ant-design/icons'
import { StampSearchTableContext } from '../stamp-search-control'

interface SelectButtonProps {
    row: StrapiDataItem<Stamp>
}

const SelectButton: FC<SelectButtonProps> = ({ row }) => {
    const { onSelectStamp } = useContext(StampSearchTableContext)

    return (
        <Button
            data-ssc-id={'id-search-popover'}
            type={'primary'}
            title={'Выбрать'}
            icon={<AimOutlined />}
            onClick={() => onSelectStamp(row)}
        />
    )
}

export default SelectButton
